<!----添加数据列表------>
<template>
  <div class="list-operation">
    <el-table :data="tableShowData">
      <el-table-column
        v-for="(column, index) in tableOptions && tableOptions.columns"
        v-if="column.isShow===false?false:true"
        show-overflow-tooltip
        :prop="column.prop"
        align="center"
        :key="index"
        :label="column.label"
        :min-width="column.width || tableOptions.width"
      >
        <template slot-scope="scope">
          <div v-show="scope.$index < tableShowData.length - 2">
            <span v-if="column.type == 'index'">{{
              page.pageSize * (page.current - 1) + scope.$index + 1
            }}</span>
            <el-input
              v-else-if="column.type == columnType.input"
              v-model="scope.row[column.prop]"
              @change="valueChange(column, scope.row, scope.$index)"
            ></el-input>
            <span v-else-if="column.type == 'operation'">
              <span
                style="cursor: pointer;color:#409EFF"
                @click="todelete(scope.$index, scope.row)"
              >删除</span
              >
            </span>
            <!--开关-->
            <el-switch
              v-else-if="column.type === columnType.switch"
              v-model="scope.row[column.prop]"
              @change="switchChange(column,scope.row,scope.$index)"
            ></el-switch>
            <div
              v-else-if="column.enumData"
              v-html="$utils.getEnumItem(column,scope.row[column.prop])"
            ></div>
            <el-input-number
              v-else-if="column.type == columnType.inputNumber"
              @change="valueChange(column, scope.row, scope.$index)"
              v-model="scope.row[column.prop]"
              :min="0"
              name="input"
              @keydown.enter.native="keyDownEnter($event)"
              @focus="selectContent($event)"
            ></el-input-number>
            <span v-else>{{ scope.row[column.prop] }}</span>
          </div>
          <div v-show="scope.$index >= tableShowData.length - 2">
            {{ scope.row[column.prop] }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <div class="fl total-cue">所有记录</div>
      <div class="fl total-cue">{{ page.total }}条</div>
      <!--分页-->
      <el-pagination
        class="tr"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.current"
        :page-size="page.pageSize"
        :page-sizes="[10, 15, 20, 30, 40]"
        layout="sizes, prev, pager, next, jumper"
        :total="page.total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
  export default {
    props: ["tableOptions"],
    data() {
      return {
        columnType: this.$utils.columnType,
        tableShowData: [], //当前页数据
        currentPageData: [],
        tableData: [], //所有数据
        tabelTotalData: [], //所有总计
        tabelPageTotalData: [], //当前页总计
        tableRow: {},
        page: {
          current: 1,
          total: 0,
          pageSize: 10
        }
      };
    },
    mounted() {
      this.tableShowData = [];
      this.tableData = [];
      this.tableOptions.columns.map(column => {
        if (column.prop) this.tableRow[column.prop] = "";
        if (column.type == "inputNumber") this.tableRow[column.prop] = 0;
      });
      this.setTableShowData();
    },
    methods: {
      initData() {
        this.tableOptions.columns.map((column) => {
          if (column.prop) this.tableRow[column.prop] = "";
          if (column.type == "inputNumber")
            this.tableRow[column.prop] = undefined;
        });
        this.$set(this.tableData, 0, this.$utils.deepClone(this.tableRow));
        // if(!this.tableOptions.showSum){
        //this.$set(this.tableData, 1, this.getSummaries(this.tableData));
        // }
      },
      // 删除
      todelete(index, row) {
        this.tableData = this.$utils.deepClone(
          this.tableData.filter(v => v.barCode !== row.barCode)
        );
        this.setTableShowData();
      },
      clearTableData() {
        this.tableData = [];
        // this.initData();
        this.setTableShowData();
      },
      setTableShowData() {
        this.currentPageData = this.tableData.slice(
          this.page.pageSize * (this.page.current - 1),
          this.page.pageSize * this.page.current
        );
        //先为当前页数据赋值再合计
        this.tabelPageTotalData = this.getPageSummaries();
        this.tabelTotalData = this.getSummaries();
        this.tableShowData = [
          ...this.currentPageData,
          ...[this.tabelPageTotalData],
          ...[this.tabelTotalData]
        ];

        console.log(this.tableShowData);
        this.page.total = this.tableData.length;
      },
      handleSizeChange(pageSize) {
        this.page.pageSize = pageSize;
        this.page.current = 1;
        this.setTableShowData();
      },
      setCountData(rowData) {
        let totalIndex = this.tableData.findIndex(
          v => v.barCode == rowData.barCode
        );
        console.log(rowData);
        this.tableData[totalIndex] = rowData;
        this.$set(this.tableData, totalIndex, rowData);
        this.setTableShowData();
      },
      // 翻页
      handleCurrentChange(value) {
        this.page.current = value;
        this.setTableShowData();
      },
      valueChange(column, row, index) {
        let totalIndex = this.tableData.findIndex(v => v.barCode == row.barCode);
        if (column.change) {
          column.change(row, totalIndex);
        } else {
          console.log(totalIndex, row);
          this.$set(this.tableData, totalIndex, row);
          this.setTableShowData();
        }
      },
      //enter实现tab切换
      keyDownEnter (event) {
        let inputs = document.getElementsByName('input');
        if (event.keyCode === 13) { // 回车
          for (let i = 0; i < inputs.length; i++) {
            if (inputs[i] === document.activeElement) {
              if (i === inputs.length) return;
              if (!inputs[i + 1]) return;
              if (inputs[i + 1].localName === 'input') {
                  inputs[i + 1].focus();
                  return;
              }
            }
          }
        }
      },
      selectContent(event) {
        event.currentTarget.select();
      },
      switchChange(column, row, index) {
        if (column.change) {
          column.change(row, index);
        } else if (column.blur) {
          column.blur(row, index);
        } else {
          this.setCountData(row, index);
        }
      },
      //当页合计
      getPageSummaries() {
        if (this.tabelTotalData.length == 0 || this.tableOptions.summaryColumns === undefined) return {};
        let sum = {};
        this.tableOptions.columns.map((column, index) => {
          if (index == 0) {
            sum[column.prop] = "当页合计";
          } else if (
            this.tableOptions.summaryColumns.indexOf(column.prop) > -1 &&
            this.currentPageData.length !== 0
          ) {
            sum[column.prop] = this.currentPageData
              .map(item => {
                return item[column.prop] || 0;
              })
              .reduce(function (prev, cur, index, array) {
                return parseFloat(prev) + parseFloat(cur);
              });
            sum[column.prop] = this.toFixed2(sum[column.prop]);
          } else {
            sum[column.prop] = "";
          }
        });
        return sum;
      },
      //总合计
      getSummaries() {
        if (this.tableData.length == 0 || this.tableOptions.summaryColumns === undefined) return {};
        let sum = {};
        this.tableOptions.columns.map((column, index) => {
          if (index == 0) {
            sum[column.prop] = "总合计";
          } else if (
            this.tableOptions.summaryColumns.indexOf(column.prop) > -1 &&
            this.tableData.length !== 0
          ) {
            sum[column.prop] = this.tableData
              .map(item => {
                return item[column.prop] || 0;
              })
              .reduce(function (prev, cur, index, array) {
                return parseFloat(prev) + parseFloat(cur);
              });
            sum[column.prop] = this.toFixed2(sum[column.prop]);
          } else {
            sum[column.prop] = "";
          }
        });
        return sum;
      },
      toFixed2(number) {
        return Number(number).toFixed(2);
      },
      //删除行
      delFun(scope) {
        let rowIndex =
          (this.page.current - 1) * this.page.pageSize + scope.$index;
        if (this.tableData.length == 1) return;
        this.tableData.splice(rowIndex, 1);
        this.setTableShowData();
      },
      //为当前行赋值
      setColumnData(rowData, index) {
        this.$set(this.tableData, index, rowData);
        this.setTableShowData();
      },
      //为多行赋值
      addMoreRow(rows, index) {
        rows.map((row, idx) => {
          this.$set(this.tableData, index + idx, row);
        });
        this.setTableShowData();
      },
      getTabelData() {
        return this.tableData;
      },
      getSumData() {
        return this.tabelTotalData;
      }
    }
  };
</script>
<style>
  .list-operation .icon {
    font-size: 20px;
    color: #5e57e3;
    font-weight: bolder;
    line-height: 40px;
    display: inline-block;
    margin-top: 3px;
    cursor: pointer;
    margin-left: 10px;
  }

  .list-operation .el-table {
    border: 1px solid #ccc;
    margin-bottom: 5px;
  }

  .list-operation .el-table__footer-wrapper tbody td,
  .list-operation .el-table__header-wrapper tbody td {
    background-color: transparent;
  }

  .list-operation .el-table th.is-leaf {
    border-right: 0;
  }

  .list-operation .el-table th,
  .list-operation .el-table tr {
    line-height: 37px;
  }

  .list-operation .pagination-box {
    position: unset;
    left: unset;
    bottom: unset;
  }

  .list-operation .el-input-number .el-input__inner {
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/template/listOperationNew.vue